/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wsnofriendsbtnok4Inputs */



/**
* | output |
* | --- |
* | "OK" |
*
* @param {Wsnofriendsbtnok4Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const wsnofriendsbtnok4 = /** @type {((inputs?: Wsnofriendsbtnok4Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wsnofriendsbtnok4Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("OK")
	if (locale === "es") return /** @type {LocalizedString} */ ("OK")
	return /** @type {LocalizedString} */ ("ОК")
});
export { wsnofriendsbtnok4 as "wsNoFriendsBtnOk" }